import HighBandwidth from "@carespace-icons/speedometer/highBandwidth";
import LowBandwidth from "@carespace-icons/speedometer/lowBandwidth";
import { Button, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { useTypedDispatch } from "@stores/index";
import { postBandwidth } from "@stores/settings/setings";

interface BandwidthModeProps {
  bandwidth: boolean | null;
  checkValue: boolean | null;
  setCheckValue: (value: boolean) => void;
  fetchNetworkMode: () => void;
}

const BandwidthMode = (props:BandwidthModeProps) => {
  const { checkValue, bandwidth, fetchNetworkMode } = props;
  const { t } = useTranslation();
  const dispatch = useTypedDispatch();

  const handleBandwidthMode = async (value: boolean) => {
    const payload = {
      networkIssue: value,
    };
    await dispatch(postBandwidth(payload));
    await fetchNetworkMode();
  }; 

  if(bandwidth) {
    return <Spin className="spin-css" style={{height:'20vh'}} tip="Loading" size="large" />;
  }

  return (
    <div className="setting-checkbox-bandwidth" style={{paddingTop: '10px'}}>
        <Button
          type="default"
          style={{
            backgroundColor: !checkValue ? 'green' : 'white',
            color: !checkValue ? 'white' : 'black',
            borderColor: !checkValue ? 'green' : '#d9d9d9',
          }}
          className="high"
          onClick={() => handleBandwidthMode(!checkValue)}>
          <HighBandwidth color={!checkValue ? 'stroke-white' : 'stroke-black'} /> {t('Admin.data.theme.high')}
        </Button>
        <Button
          type="default"
          style={{
            backgroundColor: checkValue ? 'orange' : 'white',
            color: checkValue ? 'white' : 'black',
            borderColor: checkValue ? 'orange' : '#d9d9d9',
          }}
          className="low"
          onClick={() => handleBandwidthMode(!checkValue)}>
          <LowBandwidth color={checkValue ? 'stroke-white' : 'stroke-black'} /> {t('Admin.data.theme.low')}
        </Button>
    </div>
  )
}

export default BandwidthMode;